// extracted by mini-css-extract-plugin
export var legendIndicator = "_fo-1";
export var legendRight = "_fo-0";